import { Printer } from 'lucide-react';
import { imprimirAutorizacao, type ItemAutorizacao } from '../../utils/autorizacao-html';
import { useDialog } from '../DialogProvider';

interface BotaoAutorizacaoProps {
  numero?: string | null;
  clienteNome: string;
  clienteDoc?: string | null;
  comprador?: string;
  itens?: ItemAutorizacao[];
  total: number | string;
  formaPagamento?: string;
  // 'modal' = dentro do rodape do Enviar ao Caixa (flex-1, espalha na linha dos botoes);
  // 'header' = na faixa .pagina-acoes do OrcamentoNovo (largura do conteudo).
  variante?: 'modal' | 'header';
  // Cor do botao. 'azul' (padrao) = crediario/remessa; 'laranja' (#f97316) = Venda CM (DA-381),
  // pra separar a Autorizacao do "Sim, liberar" (azul) no modal de liberacao.
  cor?: 'azul' | 'laranja';
}

// Botao "Autorizacao de Compra": imprime o comprovante (bobina 55mm) que a pessoa
// que RETIRA a mercadoria assina. Peca UNICA reusada no modal Enviar ao Caixa
// (venda em crediario) e no cabecalho da Remessa em consignacao (DA-371) —
// a mesma logica de validacao + impressao, num lugar so.
export function BotaoAutorizacao({
  numero,
  clienteNome,
  clienteDoc,
  comprador,
  itens,
  total,
  formaPagamento,
  variante = 'modal',
  cor = 'azul',
}: BotaoAutorizacaoProps) {
  const dialog = useDialog();

  function handleImprimir() {
    if (!comprador || !comprador.trim()) {
      void dialog.alerta('Preencha o campo "Retirado por:" no orcamento antes de imprimir a autorizacao.');
      return;
    }
    if (!itens || itens.length === 0) {
      void dialog.alerta('Orcamento sem itens.');
      return;
    }
    imprimirAutorizacao({
      numero: numero || 'S/N',
      data: new Date(),
      clienteNome,
      clienteDoc: clienteDoc || null,
      comprador: comprador.trim(),
      itens,
      total: Number(total),
      formaPagamento: formaPagamento || '',
    });
  }

  const bgCor = cor === 'laranja'
    ? 'bg-orange-500 hover:bg-orange-600'
    : 'bg-blue-600 hover:bg-blue-700';
  const className =
    variante === 'header'
      ? `flex items-center gap-2 ${bgCor} text-white rounded-lg px-4 py-2 text-sm font-medium transition`
      : `flex-1 flex items-center justify-center gap-2 px-4 py-2.5 ${bgCor} text-white rounded-lg text-sm font-medium transition`;

  return (
    <button
      type="button"
      data-componente="018"
      onClick={handleImprimir}
      className={className}
      title="Imprimir autorizacao de retirada (a pessoa que retira a mercadoria assina)"
    >
      <Printer size={16} />
      Autorização
    </button>
  );
}
